export interface CorDaPaleta { readonly hue: number; readonly chave: string; }

export const PELES_CRIACAO: readonly CorDaPaleta[] = [
  { hue: 1002, chave: 'aparencia.pele.porcelana' },
  { hue: 1010, chave: 'aparencia.pele.clara' },
  { hue: 1018, chave: 'aparencia.pele.pessego' },
  { hue: 1026, chave: 'aparencia.pele.dourada' },
  { hue: 1034, chave: 'aparencia.pele.morena' },
  { hue: 1042, chave: 'aparencia.pele.bronze' },
  { hue: 1050, chave: 'aparencia.pele.escura' },
  { hue: 1058, chave: 'aparencia.pele.ebano' }
];

export const CORES_CRIACAO: readonly CorDaPaleta[] = [
  { hue: 1102, chave: 'aparencia.cor.preto' },
  { hue: 1105, chave: 'aparencia.cor.castanhoEscuro' },
  { hue: 1107, chave: 'aparencia.cor.castanho' },
  { hue: 1110, chave: 'aparencia.cor.avela' },
  { hue: 1115, chave: 'aparencia.cor.ruivo' },
  { hue: 1118, chave: 'aparencia.cor.acobreado' },
  { hue: 1123, chave: 'aparencia.cor.loiroEscuro' },
  { hue: 1125, chave: 'aparencia.cor.loiro' },
  { hue: 1127, chave: 'aparencia.cor.platinado' },
  { hue: 1134, chave: 'aparencia.cor.grafite' },
  { hue: 1130, chave: 'aparencia.cor.grisalho' },
  { hue: 1137, chave: 'aparencia.cor.branco' }
];
